export default "__VITE_ASSET__79e6c2c1__"